import { render, staticRenderFns } from "./WithdrawMoneyContent.vue?vue&type=template&id=019472f6&"
import script from "./WithdrawMoneyContent.vue?vue&type=script&lang=ts&"
export * from "./WithdrawMoneyContent.vue?vue&type=script&lang=ts&"
import style0 from "./WithdrawMoneyContent.vue?vue&type=style&index=0&id=019472f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports